export default __webpack_public_path__ + "assets/images/1aaf159e270998817cebe9f4e021b065.svg";